import { Timestamp } from 'firebase/firestore';

export const formatDisplayDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return "Invalid date";
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
  };
  
export const formatTime = (date) => {
    try {
        if (!date) return 'N/A';
        
        // Handle different date formats
        let dateObj;
        if (typeof date === 'string') {
            dateObj = new Date(date);
        } else if (date instanceof Date) {
            dateObj = date;
        } else if (date && typeof date.toDate === 'function') {
            // Handle Firestore Timestamp
            dateObj = date.toDate();
        } else if (date && date.seconds) {
            // Handle Firestore Timestamp as object with seconds
            dateObj = new Date(date.seconds * 1000);
        } else {
            return 'Invalid time';
        }
        
        // Check if date is valid
        if (isNaN(dateObj.getTime())) {
            return 'Invalid time';
        }
        
        return dateObj.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    } catch (error) {
        console.error('Error formatting time:', error);
        return 'Invalid time';
    }
};

export const calculateDuration = (start, end) => {
    try {
        if (!start || !end) return 'N/A';
        
        // Handle different date formats
        let startDate, endDate;
        
        if (typeof start === 'string') {
            startDate = new Date(start);
        } else if (start instanceof Date) {
            startDate = start;
        } else if (start && typeof start.toDate === 'function') {
            startDate = start.toDate();
        } else if (start && start.seconds) {
            startDate = new Date(start.seconds * 1000);
        } else {
            return 'N/A';
        }
        
        if (typeof end === 'string') {
            endDate = new Date(end);
        } else if (end instanceof Date) {
            endDate = end;
        } else if (end && typeof end.toDate === 'function') {
            endDate = end.toDate();
        } else if (end && end.seconds) {
            endDate = new Date(end.seconds * 1000);
        } else {
            return 'N/A';
        }
        
        // Check if dates are valid
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            return 'N/A';
        }
        
        const durationMs = endDate.getTime() - startDate.getTime();
        const durationHours = Math.round(durationMs / (1000 * 60 * 60) * 10) / 10;
        return durationHours;
    } catch (error) {
        console.error('Error calculating duration:', error);
        return 'N/A';
    }
}; 